<template>
    <FormGroup
        :name="name"
        :label="label"
        :as-row="asRow"
        :size="size">
        <p class="form-control-plaintext" :class="inputClass" v-bind="$attrs">
            <slot />
        </p>
    </FormGroup>
</template>

<script>
import FormGroup from '@/js/components/common/fields/FormGroup';

export default {
    name: 'StaticField',

    components: {FormGroup},

    inheritAttrs: false,

    props: {
        name: {type: String, required: true},
        label: {type: String, default: null},

        asRow: {type: Boolean},
        size: {
            type: String,
            default: null,
            validator: (value) => ['sm', 'lg'].indexOf(value) !== -1,
        },
    },

    computed: {
        inputClass() {
            if (this.size === null) {
                return null;
            }

            return `form-control-${this.size}`;
        },
    },

    methods: {
        focus() {
            this.$el.scrollIntoView(true);
        },
    },
};
</script>
